import { render, staticRenderFns } from "./pictCard.vue?vue&type=template&id=698400a3"
import script from "./pictCard.vue?vue&type=script&lang=js"
export * from "./pictCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports